


















import { Component, Vue, Prop } from 'vue-property-decorator';
import Slide from '../../interfaces/models/Slide';

@Component({
  components: {}
})
export default class CartPreview extends Vue {
  @Prop({ type: Object }) cartMap?: { [key: string]: Slide };
}
